import { Box, Divider, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { resetPageModifiedFilter, setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import SearchAppBar from "components/common/searchBar";
import Spinner from "components/common/Spinner/Spinner";
import Toggle from "components/common/Toggle";
import Typography from "components/common/Typography";
import { fetchMyPlanDetailAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { nestedTernaryCheckerCond2 } from "utils/CommonChecker";
import { DEFAULT_CORP_INNCODE, PAGE_SIZE, allPlansType, tabConstants } from "utils/CommonConstants";
import {
  convertArrayValuesToString,
  formFilterRequestPayload,
  getHltInncodes,
  getMembersList
} from "utils/CommonFunctions";
import {
  clearPlanProgress,
  fetchAbovePropertyMyPlansAsync,
  fetchAssigneeDetailsByHtlIdsAsync,
  fetchPlansSummary,
  setLoader
} from "../../AboveProperty.slice";
import "./index.scss";
import PlanDetails from "./PlanDetails";
import PlansProgress from "./PlansProgress";
import UnImplementedProperties from "./UnImplementedProperties";

const PlanProgress = () => {
  const translate = useTranslate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const { isMobileScreen } = useContext(ThemeContext);

  const {
    totalList,
    plansList: userplans,
    inncodes: inncodesList
  } = useAppSelector((state) => state.aboveProperty.planProgress);
  const {
    abovePropertyLoader,
    roleCategoryList,
    multiTargetDetails: multiTargetInfo,
    progressSummaryLoader
  } = useAppSelector((state) => state.aboveProperty);
  const [pageNo, setPageNo] = useState(0);
  const [toggleOn, setToggleOn] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const redirectFrom = searchParams.get("redirectFrom");
  const isTemplatePlan = redirectFrom === tabConstants.AssignedCustomPlans;
  const location = useLocation();
  const progressInncodes = location?.state?.progressInncodes;
  const isdeadlineOrInitiative =
    tabConstants.BrandDeadline === redirectFrom || tabConstants.BrandInitiative === redirectFrom;

  const pageName = filterPage.planProgressFromPlansDisplay;
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[pageName]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload, convertArrayValuesToString);
  const inncode = formattedFilterRequestPayload["innCode"];
  const searchText = globalFiltersforPage?.searchText;

  const innCode = nestedTernaryCheckerCond2(
    inncode,
    location?.state?.watchListPlan,
    inncode,
    getHltInncodes(true),
    progressInncodes?.join(",")
  );
  formattedFilterRequestPayload["innCode"] = innCode;

  // Function to remove undefined and empty string values from an array
  const filteredRoleCategory = [formattedFilterRequestPayload["roleCategory"]].filter(
    (roleCategory) => roleCategory !== undefined && roleCategory !== ""
  );

  if (filteredRoleCategory?.length) {
    formattedFilterRequestPayload["roleCategory"] = formattedFilterRequestPayload["roleCategory"].split(",");
  }

  const getProps = (startPage?: number) => {
    if (startPage === 0) setPageNo(startPage);
    const props = {
      includeOwners: true,
      includeFilters: true,
      searchedPropertyText: searchText,
      ...formattedFilterRequestPayload
    };
    const idValue = isTemplatePlan ? { templatePlanIds: [Number(params.id)] } : { cmsId: params.id };
    const page = startPage ?? pageNo;
    const payload = { ...props, ...idValue };
    return { payload, page };
  };

  const getPlanSummary = async () => {
    const payload = {
      filter: {
        innCode: DEFAULT_CORP_INNCODE,
        ids: [params?.id],
        functionalAreaIds: [],
        filterIds: []
      },
      pagination: { page: 1, size: PAGE_SIZE },
      searchText: "",
      planType: [allPlansType]
    };

    await dispatch(fetchPlansSummary(payload));
  };

  const getPlanProgress = async (props: any) => {
    const plans = await dispatch(fetchAbovePropertyMyPlansAsync(props));
    const planOwners = plans?.payload?.meta?.owners;
    if (planOwners?.length) {
      const data = {
        value: planOwners.join(","),
        size: planOwners?.length
      };
      await dispatch(fetchAssigneeDetailsByHtlIdsAsync(data));
    }
    dispatch(setLoader(false));
  };
  useEffect(() => {
    if (pageNo > 0) {
      dispatch(fetchAbovePropertyMyPlansAsync(getProps()));
    }
  }, [pageNo]);

  useEffect(() => {
    if (isTemplatePlan) {
      dispatch(fetchMyPlanDetailAsync({ id: params?.id }));
    } else getPlanSummary();

    return () => {
      dispatch(clearPlanProgress());
    };
  }, []);

  useEffect(() => {
    getPlanProgress(getProps(0));
  }, [searchText, filterRequestPayload]);

  const fetchPlans = async (page?: number) => {
    await dispatch(fetchAbovePropertyMyPlansAsync(getProps(page)));
    dispatch(setLoader(false));
  };

  const handleToggle = async (val: boolean) => {
    setToggleOn(val);
    if (val) {
      dispatch(
        resetPageModifiedFilter({
          pageName: [filterPage.planProgressUnimplementedFromPlansDisplay]
        })
      );
      fetchPlans(0);
    } else {
      dispatch(
        resetPageModifiedFilter({
          pageName: [filterPage.planProgressFromPlansDisplay]
        })
      );
    }
  };
  return (
    <>
      {(abovePropertyLoader || progressSummaryLoader) && <Spinner backdropVisible />}

      <PlanDetails isTemplatePlan={isTemplatePlan} />
      {
        <>
          <Grid sx={{ marginTop: "24px", marginBottom: "24px" }}>
            {" "}
            <Typography variant={"h5"} color={tokens.Text.General.PrimaryHeadline} showBold>
              {translate("dashboard.planInProgress")}
            </Typography>
          </Grid>
          <Box
            sx={{
              backgroundColor: tokens.Background.General.Primary,
              borderRadius: "12px"
            }}
          >
            {isdeadlineOrInitiative && !toggleOn ? (
              <>
                {" "}
                <UnImplementedProperties
                  toggleOn={toggleOn}
                  handleToggle={(val: boolean) => {
                    handleToggle(val);
                  }}
                  cmsId={params?.id}
                />
              </>
            ) : (
              <>
                <Box sx={{ padding: "16px 8px" }}>
                  <Box className="filter-searchbar-wrapper">
                    <SearchAppBar
                      isPreDefinedNav={true}
                      value={searchText}
                      placeholder="Search by Property"
                      sx={{
                        minWidth: isMobileScreen ? "initial" : "350px",
                        border: `solid 1px ${tokens.Border.General.Tertiary}`
                      }}
                      getInputDetails={(val) =>
                        dispatch(
                          setPageFilter({
                            pageName: pageName,
                            searchText: val
                          })
                        )
                      }
                    />
                    <Box className={isdeadlineOrInitiative ? "toggle-filters" : "non-toggle-filters"}>
                      {isdeadlineOrInitiative && (
                        <Toggle
                          onChange={(val: boolean) => handleToggle(val)}
                          isToggleEnabled={true}
                          sx={{ marginTop: "4px", marginLeft: isMobileScreen ? "8px" : "20px" }}
                          isLabelLeftSide={true}
                        />
                      )}
                      <GlobalFilters
                        page={pageName}
                        getMembersList={(searchValue: string) => getMembersList(searchValue, dispatch)}
                      />
                    </Box>
                  </Box>
                  <GlobalFilterDescription page={pageName} />
                </Box>
                <Divider />
                <PlansProgress
                  data={userplans}
                  totalList={totalList}
                  pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
                />
              </>
            )}
          </Box>
        </>
      }
    </>
  );
};

export default PlanProgress;
